if (!customElements.get('bio-sticky')) {
  customElements.define(
    'bio-sticky',
    class BioSticky extends HTMLElement {
      connectedCallback() {
        this.trigger = document.querySelector('.bp-form [name="add"]') || document.querySelector('[data-bsk-trigger]');
        this.button = this.querySelector('[data-bsk-button]');
        if (!this.trigger || !('IntersectionObserver' in window)) return;

        this.measure = () => this.style.setProperty('--bsk-w', `${this.offsetWidth}px`);
        this.measure();
        window.addEventListener('resize', this.measure, { passive: true });

        this.observer = new IntersectionObserver(([entry]) => {
          if (!entry.isIntersecting && entry.boundingClientRect.bottom < 0) {
            this.show();
          } else {
            this.hide();
          }
        });
        this.observer.observe(this.trigger);

        this.button?.addEventListener('click', () => this.start());
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        this.observer?.disconnect();
        window.removeEventListener('resize', this.measure);
      }

      show() {
        clearTimeout(this.timer);
        this.measure();
        this.classList.add('is-in');
        this.timer = setTimeout(() => this.classList.add('is-open'), 520);
      }

      hide() {
        clearTimeout(this.timer);
        this.classList.remove('is-open');
        if (!this.classList.contains('is-in')) return;
        this.timer = setTimeout(() => this.classList.remove('is-in'), 300);
      }

      async start() {
        this.button.classList.add('is-busy');
        const inCart = await this.isInCart();
        if (inCart) {
          this.openCart();
        } else {
          this.trigger.click();
        }
        setTimeout(() => this.button.classList.remove('is-busy'), 1200);
      }

      async isInCart() {
        try {
          const response = await fetch(`${this.dataset.cart}.js`, { headers: { Accept: 'application/json' } });
          const cart = await response.json();
          return cart.items.some((item) => String(item.product_id) === this.dataset.product);
        } catch (error) {
          return false;
        }
      }

      openCart() {
        const drawer = document.querySelector('cart-drawer');
        if (drawer) {
          drawer.open();
        } else {
          window.location.href = this.dataset.cart;
        }
      }
    }
  );
}
